import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router,ActivatedRoute} from "@angular/router";
import { NgxSmartModalService } from 'ngx-smart-modal';
import { HttpParams } from '@angular/common/http';
import { LOCALE_ID, Inject } from '@angular/core';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  constructor(@Inject(LOCALE_ID) protected localeId: string, public ngxSmartModalService: NgxSmartModalService, private http: HttpClient, private router: Router) { }
  profileName = '';
  uuid = '';
  siteID = environment.siteID;
  passShort:boolean = false;
  mobileNumber = '';
  otpSent:boolean = false;
  loaded:boolean = false;
  newPassword = '';
  newPasswordAgain = '';
  ngOnInit() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 1500);
  }
  onUUIDKeyUp(event:any){
    this.uuid = event.target.value;
  }
  onMobNumKeyUp(event:any){
    this.mobileNumber = event.target.value;
    this.mobileNumber = this.mobileNumber.replace(/\s/g, '').substring(1)
    console.log(this.mobileNumber);
  }
  onNewPasswordKeyUp(event:any){
    this.newPassword = event.target.value;
  }
  onNewPasswordAgainKeyUp(event:any){
    this.newPasswordAgain = event.target.value;
  }
  refresh(): void {
    window.location.reload();
}
  public sendOTP(){
    var baseUrl =  "https://api-staging.videyo.tv" //"http://localhost:8080" //"http://videyo-tmp.eu-west-2.elasticbeanstalk.com"

    this.http.get(baseUrl+'/manage/forgotPassword?phoneNumber='+this.mobileNumber+'&siteID='+this.siteID, {
    }).subscribe(
        data => {
           this.otpSent = true;
        },
        error => {
          console.log('ERROR:');
          console.log(error);
        }
    );


    return false;
}
  public forgotUser(){
    if (this.newPassword.length < 6 || this.newPasswordAgain.length < 6 ) { 
      this.passShort = true;
    }
    else {
      var baseUrl =  "https://api-staging.videyo.tv" //"http://localhost:8080" //"http://videyo-tmp.eu-west-2.elasticbeanstalk.com"
      // now use this username and password to login.

      this.http.get(baseUrl+'/manage/resetPassword?username='+this.mobileNumber+'&uuid='+this.uuid+'&newPassword='+this.newPassword+'&newPasswordAgain='+this.newPasswordAgain, {
      }).subscribe(
          data => {
          },
          error => {
            console.log('ERROR:');
            console.log(error);
          }
      );


      return false;
  }
  }
}
